import React from "react"
import {ClearButton} from "./components"

export const StandardClearButton = ({dataGaV1, dataGaV2, dataGaV3, children, onClick}) => {
    return (
        <ClearButton
            data-testid="header-recent-searches-clear-button"
            data-ga-v1={dataGaV1}
            data-ga-v2={dataGaV2}
            data-ga-v3={dataGaV3}
            onClick={onClick}
        >
            {children}
        </ClearButton>
    )
}

export default StandardClearButton
